import React, { useState, useEffect } from 'react';
import { Link , useLocation  } from 'react-router-dom';
import AuthenticatedLayout from './layouts/AuthenticatedLayout';
import Home from './pages/Home';
import RecommendationsPage from './pages/RecommendationsPage';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import VideoBackground from './components/VideoBackground';
import UniversitySlider from './components/UniversitySlider';
import SignInSignUp from './pages/SignInSignUp';
import Questionnaire from './components/dashboard/Questionnaire'; // Adjust path if needed
import BulkEmailPage from './pages/BulkEmailPage';
import SignupForm from './components/SignupForm/SignupForm';

import 'jquery';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './FontAwesome.css';
import './App.css';
import './Owl.css';
import './LightBox.css';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Chatbot from './components/chatbot/Chatbot'; // adjust the path if needed
import Modal from 'react-modal';

// axios.defaults.withCredentials = true;
// Blog System Imports
import BlogPage from './blog/pages/BlogPage'; 
import SinglePostPage from './blog/pages/SinglePostPage';
import BlogAdminDashboard from './blog/pages/BlogAdminDashboard';
import PostEditor from './blog/pages/PostEditor';
import BlogAdminLogin from './blog/pages/BlogAdminLogin';
import BlogLayout from './layouts/BlogLayout';
import './components/AccessDenied.css'; // Add CSS file
import AdminControl from './components/AnalyticsDashboard'



const App = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  Modal.setAppElement('#root'); // For accessibility

//   useEffect(() => {
//   if (location.pathname === '/') {
//     axios.get(`${process.env.REACT_APP_API_URL}/blog/popup`)
//       .then(res => {
//         console.log("Popup fetched:", res.data);
//         if (res.data?.isActive) {
//           setPopupData(res.data);
//           setShowPopup(true);
//         }
//       })
//       .catch(err => console.error('Popup fetch error:', err));
//   }
// }, [location.pathname]); // 👈 re-run if path changes

  
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('authToken');
      const storedUser = localStorage.getItem('user');
      
      
      if (token && storedUser) {
        setUser(JSON.parse(storedUser));
      }
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  // ✅ MODIFY HERE
  useEffect(() => {
    if (user && window.location.pathname === '/auth') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

const ProtectedRoute = ({ children }) => {
  // Wait for loading to finish
  if (isLoading) return <div>Loading...</div>;

  // 👇 check localStorage instantly before redirecting
  const storedUser = localStorage.getItem("user");
  if (!user && !storedUser) {
    return <Navigate to="/auth" replace />;
  }

  // If localStorage exists but React state hasn’t caught up yet,
  // setUser immediately so the Dashboard can render.
  if (!user && storedUser) {
    setUser(JSON.parse(storedUser));
  }

  return (
    <AuthenticatedLayout user={user || JSON.parse(storedUser)} handleLogout={handleLogout}>
      {children}
    </AuthenticatedLayout>
  );
};

 // Admin-only protected route
 const AdminProtectedRoute = ({ children }) => {
  if (isLoading) {
    return <div>Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/auth" />;
  }
  
  if (user.role !== 'admin') {
    return (
      <AuthenticatedLayout user={user} handleLogout={handleLogout}>
        <div className="access-denied-container">
  <div className="access-denied-icon">🚫</div>
  <h2 className="access-denied-title">Access Denied</h2>
  <p className="access-denied-message">
    You don't have permission to access this page. Admin privileges required.
  </p>
  <button 
    onClick={() => navigate('/dashboard')}
    className="access-denied-button"
  >
    Go to Dashboard
  </button>
</div>
      </AuthenticatedLayout>
    );
  }
  
  return <AuthenticatedLayout user={user} handleLogout={handleLogout}>{children}</AuthenticatedLayout>;
};


  if (isLoading) {
    return <div>Loading...</div>;
  }
  
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
    navigate('/');
  };

  // Create a function to handle user authentication that includes navigation
 const handleAuthentication = async (userData) => {
  setUser(userData);
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/questionnaires/status/${userData.id}`);
    const hasCompleted = response.data.hasAnswered;
    
    if (!hasCompleted) {
      setShowQuestionnaire(true);
    } else {
      navigate('/dashboard');
    }
  } catch (error) {
    console.error('Failed to check questionnaire status:', error);
    navigate('/dashboard');
  }
};

const handleQuestionnaireSubmit = (data) => {
  setUser(prev => ({ ...prev, hasCompletedQuestionnaire: true }));
  setShowQuestionnaire(false);
  navigate('/dashboard');
};


  return (
    <>
    {/*{showQuestionnaire && user && (
      <Questionnaire
        user={user}
        onSubmit={handleQuestionnaireSubmit}
        onClose={() => setShowQuestionnaire(false)}
        onUpdate={() => {}}
      />
    )}*/}
   {/* {location.pathname === '/' && (
  <Modal
    isOpen={showPopup}
    onRequestClose={() => setShowPopup(false)}
    className="popup-content"
    overlayClassName="popup-overlay"
  >
    <button className="popup-close-btn" onClick={() => setShowPopup(false)}>
      &times;
    </button>
    <div dangerouslySetInnerHTML={{ __html: popupData?.content || "<p>No popup content</p>" }} />
  </Modal>
)} */}



    <Routes>
      
      <Route path="/" element={
  <>
    <Home isAuthenticated={!!user} user={user} handleLogout={handleLogout} />
    <Chatbot />
  </>
} />

      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/signup" element={<SignupForm />} />

      <Route path="/" element={
        <Home isAuthenticated={!!user} user={user} handleLogout={handleLogout} />
      } />
      <Route path="/auth" element={
        <SignInSignUp setUser={handleAuthentication} />
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard user={user} setUser={setUser} handleLogout={handleLogout} />
        </ProtectedRoute>
      } />
      <Route path="/recommendations" element={
        <ProtectedRoute>
          <RecommendationsPage user={user} setUser={setUser} handleLogout={handleLogout} />
        </ProtectedRoute>

      } />
      {/* Blog System Routes wrapped in BlogLayout */}
      {/* <Route path="/blog" element={<BlogLayout><BlogPage /></BlogLayout>} />
      <Route path="/post/:id" element={<BlogLayout><SinglePostPage /></BlogLayout>} /> */}
      {/* <Route path="/admin" element={<BlogLayout><BlogAdminDashboard /></BlogLayout>} /> */}
      {/* <Route path="/admin/new" element={<BlogLayout><PostEditor /></BlogLayout>} />
      <Route path="/admin/edit/:id" element={<BlogLayout><PostEditor /></BlogLayout>} />
      <Route path="/admin/login" element={<BlogLayout><BlogAdminLogin setIsAdmin={setIsAdmin} /></BlogLayout>} /> */}
        <Route path="/admincontrol" element={<AdminControl user={user} />} />


    <Route
    path="/blog"
    element={
      <BlogLayout user={user} isAuthenticated={!!user} handleLogout={handleLogout}>
        <BlogPage />
      </BlogLayout>
    }
  />

  {/* accept either /post/16 or /post/my-title-p16 */}
  <Route
    path="/post/:idOrSlug"
    element={
      <BlogLayout user={user} isAuthenticated={!!user} handleLogout={handleLogout}>
        <SinglePostPage />
      </BlogLayout>
    }
  />

  <Route
    path="/admin"
    element={
      <AdminProtectedRoute>
        <BlogAdminDashboard user={user} handleLogout={handleLogout} />
      </AdminProtectedRoute>
    }
  />

  <Route
    path="/admin/new"
    element={
      <BlogLayout user={user} isAuthenticated={!!user} handleLogout={handleLogout}>
        <PostEditor />
      </BlogLayout>
    }
  />

  {/* allow opening editor by id OR slug */}
  <Route
    path="/admin/edit/:idOrSlug"
    element={
      <BlogLayout user={user} isAuthenticated={!!user} handleLogout={handleLogout}>
        <PostEditor />
      </BlogLayout>
    }
  />


            {/* Admin-only Bulk Email Route */}
            <Route path="/bulk-email" element={
        <AdminProtectedRoute>
          <BulkEmailPage user={user} setUser={setUser} handleLogout={handleLogout} />
        </AdminProtectedRoute>
      } />
      <Route path="/admin" element={
  <AdminProtectedRoute>
    <BlogAdminDashboard user={user} handleLogout={handleLogout} />
  </AdminProtectedRoute>
} />

    </Routes></>
    
  );
};

export default App;
